import React from 'react';
import { useHawksearch } from 'react-hawksearch';

function getTabCssClassName(tabValues, index: number): string {
	const tabSelectedValue = tabValues.filter(t => t.Selected);
	const bootstrapClasses = 'tab-item-link';
	// // Make default selection
	if (tabSelectedValue.length === 0 && index === 0) {
		return `${bootstrapClasses} active`;
	}
	if (tabValues[index].Selected) {
		return `${bootstrapClasses} active`;
	}
	return `${bootstrapClasses}`;
}
function Tabs() {
	const {
		store: { searchResults },
		actor,
	} = useHawksearch();

	const tabFacet = searchResults && searchResults.Facets.find(facet => facet.FieldType === 'tab');
	const element = document.getElementsByClassName('hawk-results__listing');
	const component = document.getElementById('react-app');
	if (!tabFacet) {
		return null;
	}
	return (
		<div className="product-details-tab">
			<ul className="tab-list">
				{tabFacet.Values.map((tabValue, index, tabValues) => {
					return (
						<li key={`results_type_tab_${index}`}>
							<a
								className={getTabCssClassName(tabValues, index)}
								data-type={tabValue.Label}
								onClick={() => {
									actor.setFacetValues(tabFacet, [tabValue]);
									if (tabValue.Label === 'Content') {
										if (element) {
											element[0].classList.remove('grid');
											element[0].classList.remove('list');
										}
									} else {
										if (component && component.getAttribute('data-display-mode') === 'grid') {
											if (element) {
												element[0].classList.add('grid');
												element[0].classList.remove('list');
											}
										} else if (
											component &&
											component.getAttribute('data-display-mode') === 'list'
										) {
											if (element) {
												element[0].classList.add('list');
												element[0].classList.remove('grid');
											}
										}
									}
								}}
							>
								{tabValue.Label}
							</a>
						</li>
					);
				})}
			</ul>
		</div>
	);
}

export default Tabs;
